import ConfigUtils, { DeploymentType, IConfig, SourceApp } from '../../../Config';
import WebUtils from '../../../services/WebUtils';
import { ITag } from '../../models/ITag';
import { ITagsProvider } from './ITagsProvider'

export class TagsWebProvider implements ITagsProvider {
    private webUtils: WebUtils;
    private config: IConfig;
    
    constructor(sourceApp: SourceApp, deploymentType: DeploymentType){
        this.config = ConfigUtils.getConfig(sourceApp, deploymentType);
        this.webUtils = new WebUtils(this.config);
    }
    
    public getAllTags(): Promise<{allTags: ITag[], userTags: ITag[]}> {
        return new Promise((resolve, reject) => {
            this.webUtils.ajax(
				this.webUtils.getAbsoluteBackendUrl("/followedTags/allTags"),
                data => {
                    if(data.allTags){
                        for(let i = 0; i < data.allTags.length; i++){
                            const tag = data.allTags[i];
                            if(tag && tag.imageUrl){
                                tag.imageUrl = this.config.images.marketplace + "/" + tag.imageUrl;
                            }
                        }
                    }
                    resolve(data)
                },
                error => reject(error),
                {}, 
                false, 
                true
            );
        });
    }
    
    public followTag(tag: ITag): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.webUtils.ajax(
				this.webUtils.getAbsoluteBackendUrl("/followedTags/followTag"),
                data => resolve(data),
                error => reject(error),
                {
                    tagId: tag.id 
                }, false, true
            );
        });
    }
    
    public unfollowTag(tag: ITag): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.webUtils.ajax(
				this.webUtils.getAbsoluteBackendUrl("/followedTags/unfollowTag"),
                data => resolve(data),
                error => reject(error),
                {
                    tagId: tag.id 
                }, false, true
            );
        });
    }
}